// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

.App-header {
  padding: 40px 20px;
  max-width: 800px;
  margin: 0 auto;
}

.App-header h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  animation: fadeInDown 1s ease-out;
}

.welcome-section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem 0;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: fadeInUp 1s ease-out 0.2s both;
}

.welcome-section h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #fff;
}

.time-display {
  font-size: 1.2rem;
  color: #e0e0e0;
  font-weight: 300;
}

.feature-section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem 0;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: fadeInUp 1s ease-out 0.4s both;
}

.feature-section h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
}

.feature-section ul {
  list-style: none;
  padding: 0;
}

.feature-section li {
  font-size: 1.1rem;
  margin: 0.8rem 0;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.feature-section li:hover {
  transform: translateX(5px);
  background: rgba(255, 255, 255, 0.2);
}

.action-section {
  margin: 2rem 0;
  animation: fadeInUp 1s ease-out 0.6s both;
}

.test-button {
  background: linear-gradient(45deg, #ff6b6b, #ee5a24);
  border: none;
  color: white;
  padding: 15px 30px;
  font-size: 1.1rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  font-weight: 600;
}

.test-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  background: linear-gradient(45deg, #ee5a24, #ff6b6b);
}

.test-button:active {
  transform: translateY(0);
}

.App-footer {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: #e0e0e0;
  animation: fadeIn 1s ease-out 0.8s both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 新增样式用于完整的Web应用界面 */

.app-container {
  min-height: 100vh;
  padding: 20px;
}

.page-content {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-section {
  text-align: center;
  margin-bottom: 3rem;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  position: relative;
}

.env-badge {
  position: absolute;
  top: -10px;
  right: -20px;
  background: linear-gradient(45deg, #f59e0b, #f97316);
  color: white;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  animation: envBadgePulse 2s ease-in-out infinite;
}

@keyframes envBadgePulse {
  0% {
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
  }
  50% {
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.6);
  }
  100% {
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
  }
}

/* 测试环境徽章样式 */
.env-badge.test-badge {
  background: linear-gradient(45deg, #06B6D4, #0891B2);
  color: white;
  box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);
  animation: testBadgePulse 2s ease-in-out infinite;
}

@keyframes testBadgePulse {
  0% {
    box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);
  }
  50% {
    box-shadow: 0 4px 12px rgba(6, 182, 212, 0.6);
  }
  100% {
    box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);
  }
}

/* 大学选择功能样式 */
.university-selection {
  margin: 2rem 0;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.university-label {
  margin-bottom: 1rem;
}

.university-label label {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Tab页切换样式 */
.university-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 1.5rem;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 4px;
}

.tab-button {
  flex: 1;
  padding: 12px 20px;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.tab-button:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.tab-button.active {
  background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%);
  color: #1e3a8a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border: none;
}

.tab-button:not(.active) {
  background: rgba(255, 255, 255, 0.035);
}

/* 拼音搜索模式样式 */
.search-mode {
  position: relative;
  margin-bottom: 30px;
  /* 确保有足够空间显示搜索结果 */
  min-height: 60px;
}

.search-input-container {
  position: relative;
  margin-bottom: 10px;
}

.university-search-input {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  color: #1a1a1a;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.university-search-input:focus {
  outline: none;
  border-color: #2563eb;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
}

.university-search-input::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.search-loading {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
}

/* 搜索结果下拉列表 */
.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 2px solid rgba(37, 99, 235, 0.4);
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
  margin-top: 4px;
}

.search-result-item {
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(100, 181, 246, 0.1);
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background: rgba(100, 181, 246, 0.1);
}

.search-result-item:last-child {
  border-bottom: none;
}

.university-name {
  color: #333;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
}

.university-info {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}

.search-no-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.98);
  border: 2px solid rgba(37, 99, 235, 0.4);
  border-radius: 10px;
  margin-top: 4px;
  z-index: 1000;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
}

/* 三级联动选择模式样式 */
.cascade-mode {
  margin-bottom: 15px;
}

.cascade-selects {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.cascade-select {
  flex: 1;
  min-width: 150px;
  padding: 0.8rem 1rem;
  border: 2px solid rgba(100, 181, 246, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.cascade-select:focus {
  outline: none;
  border-color: #64B5F6;
  box-shadow: 0 0 0 2px rgba(100, 181, 246, 0.2);
}

.cascade-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: rgba(255, 255, 255, 0.5);
}

.cascade-select option {
  background: #fff;
  color: #333;
}

/* 已选择的大学显示 */
.selected-university {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid #16a34a;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.selected-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.selected-name {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.2rem;
  text-shadow: none;
  letter-spacing: 0.3px;
}

.selected-detail {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  font-weight: 500;
  text-shadow: none;
}

.clear-university-button {
  padding: 8px 14px;
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.clear-university-button:hover {
  background: linear-gradient(135deg, #dc2626, #b91c1c);
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.4);
}

.university-tip {
  margin-top: 0.5rem;
}

.university-tip p {
  color: #e3f2fd;
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.8;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .cascade-selects {
    flex-direction: column;
  }
  
  .cascade-select {
    min-width: unset;
  }
  
  .selected-university {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .clear-university-button {
    align-self: flex-end;
  }
  
  .university-tabs {
    flex-direction: column;
    gap: 4px;
  }
  
  .tab-button {
    border-radius: 6px;
  }
  
  /* 移动端搜索结果优化 */
  .search-results,
  .search-no-results {
    margin: 0 10px;
    max-width: calc(100vw - 40px);
  }
  
  .search-mode {
    margin-bottom: 40px;
  }
}

/* 大学选择器组件样式 */
.university-selector {
  margin: 1.5rem 0;
}

.university-selector-header {
  margin-bottom: 1rem;
}

.university-selector-header label {
  color: #64B5F6;
  font-size: 1.1rem;
  font-weight: 600;
}

.selected-university {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: rgba(76, 175, 80, 0.1);
  border: 2px solid rgba(76, 175, 80, 0.3);
  border-radius: 8px;
  margin-bottom: 1rem;
}

.selected-info {
  flex: 1;
}

.selected-name {
  color: #4CAF50;
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

.selected-details {
  color: #e8f5e8;
  font-size: 0.9rem;
  opacity: 0.8;
}

.clear-button {
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #f44336, #d32f2f);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.clear-button:hover {
  background: linear-gradient(135deg, #d32f2f, #c62828);
  transform: translateY(-1px);
}

.university-input-placeholder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  margin-bottom: 1rem;
}

.university-input-placeholder span {
  color: #e0e0e0;
  opacity: 0.7;
}

.select-university-button {
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #2196F3, #1976d2);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.select-university-button:hover {
  background: linear-gradient(135deg, #1976d2, #1565c0);
  transform: translateY(-1px);
}

/* 开发环境徽章样式 */
.env-badge.dev-badge {
  background: linear-gradient(45deg, #f59e0b, #f97316);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);
  animation: envBadgePulse 2s ease-in-out infinite;
}

.app-header h1 {
  font-size: 2.5rem;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

.app-icon {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.app-icon:hover {
  transform: scale(1.1) rotate(5deg);
}

.hero-description {
  font-size: 1.2rem;
  margin: 1rem 0;
  color: #e0e0e0;
}

.hero-subtitle {
  font-size: 1rem;
  margin: 1rem 0 2rem 0;
  color: #ffd700;
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.feature-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.supported-features {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem 0;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.supported-features h3 {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  color: #fff;
}

.features-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(5px);
}

.feature-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.feature-text {
  font-size: 0.95rem;
  color: #e0e0e0;
  line-height: 1.4;
}

.quick-actions {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2rem;
  justify-content: center;
  flex-wrap: wrap;
}

.query-input {
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  min-width: 280px;
}

.query-input.large {
  min-width: 300px;
  padding: 15px 20px;
  font-size: 1.1rem;
}

.query-button, .primary-button, .upload-button, .download-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.query-button {
  background: linear-gradient(45deg, #4CAF50, #45a049);
  color: white;
}

.primary-button {
  background: linear-gradient(45deg, #2196F3, #1976D2);
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
}

.upload-button {
  background: linear-gradient(45deg, #FF9800, #F57C00);
  color: white;
}

.download-button {
  background: linear-gradient(45deg, #9C27B0, #7B1FA2);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.3);
}

.download-button:hover {
  background: linear-gradient(45deg, #7B1FA2, #6A1B9A);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.4);
}

.download-button.disabled {
  background: linear-gradient(45deg, #757575, #616161);
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.download-button:disabled {
  background: linear-gradient(45deg, #757575, #616161);
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.back-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 1rem;
}

.page-header {
  margin-bottom: 2rem;
}

.upload-section, .query-section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.query-input-section {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.query-error {
  margin: 1rem 0;
  padding: 1rem 1.5rem;
  background: rgba(244, 67, 54, 0.15);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 8px;
  text-align: center;
  animation: fadeInUp 0.3s ease-out;
}

.query-error p {
  margin: 0;
  color: #ffcdd2;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.4;
}

.upload-area {
  text-align: center;
  margin-bottom: 2rem;
}

.file-input {
  display: none;
}

.file-label {
  display: inline-block;
  padding: 2rem;
  border: 2px dashed rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 300px;
  max-width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.file-label:hover {
  border-color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.1);
}

.file-info {
  margin-top: 1rem;
  color: #e0e0e0;
}

.upload-tips {
  margin-top: 2rem;
  text-align: left;
}

.upload-tips ul {
  list-style-type: disc;
  padding-left: 2rem;
}

.upload-tips li {
  margin: 0.5rem 0;
  color: #e0e0e0;
}

.important-notice {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2), rgba(255, 152, 0, 0.1));
  border: 2px solid #FFC107;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
  animation: pulse-warning 2s ease-in-out infinite;
}

.important-notice h4 {
  color: #FFC107;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: 700;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

.important-notice p {
  color: #fff3c4;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.5;
}

@keyframes pulse-warning {
  0% {
    box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
  }
  50% {
    box-shadow: 0 6px 20px rgba(255, 193, 7, 0.5);
  }
  100% {
    box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
  }
}

.process-steps {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.process-steps h4 {
  margin-bottom: 1.5rem;
  color: #64B5F6;
  font-size: 1.1rem;
}

.steps {
  display: grid;
  gap: 1rem;
}

.step {
  padding: 1rem;
  background: rgba(33, 150, 243, 0.1);
  border-radius: 8px;
  border-left: 4px solid #2196F3;
  color: #e3f2fd;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.step:hover {
  background: rgba(33, 150, 243, 0.15);
  transform: translateX(5px);
}

.task-result {
  margin-top: 2rem;
}

.task-info {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  white-space: nowrap;
  overflow: hidden;
}

.info-item label {
  font-weight: 600;
  color: #e0e0e0;
  margin-right: 1rem;
  flex-shrink: 0;
}

.info-item span {
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: right;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.status.pending {
  background: #FFC107;
  color: #000;
}

.status.processing {
  background: #2196F3;
  color: white;
}

.status.completed {
  background: #4CAF50;
  color: white;
}

.status.failed {
  background: #F44336;
  color: white;
}

.error-message {
  margin-top: 1rem;
  padding: 1rem;
  background: rgba(244, 67, 54, 0.2);
  border-radius: 8px;
  border-left: 4px solid #F44336;
}

.error-code {
  background: rgba(244, 67, 54, 0.4);
  color: #ffcdd2;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  font-weight: 600;
}

.result-files {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 2rem;
}

.file-list {
  display: grid;
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.file-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.file-item .file-info h4 {
  margin: 0 0 0.3rem 0;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: help;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.file-item .file-info p {
  margin: 0.5rem 0;
  color: #e0e0e0;
  font-size: 0.95rem;
}

.file-description {
  font-size: 0.9rem !important;
  color: #e0e0e0 !important;
  line-height: 1.4;
  margin: 0.2rem 0 0.5rem 0 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: initial !important;
}

.file-size {
  color: #bbb;
  font-size: 0.85rem;
  font-weight: 500;
  flex-shrink: 0;
}

.file-item .file-info h4 .file-size {
  color: #ccc;
  font-size: 0.9rem;
  font-weight: 400;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .App-header h1 {
    font-size: 2rem;
  }
  
  .app-header {
    flex-direction: column;
    gap: 0.8rem;
  }

  .app-header h1 {
    font-size: 1.8rem;
  }

  .app-icon {
    width: 40px;
    height: 40px;
  }
  
  .hero-subtitle {
    font-size: 0.9rem;
    margin: 1rem 0 1.5rem 0;
  }
  
  .features-list {
    grid-template-columns: 1fr;
  }
  
  .feature-item {
    padding: 0.8rem;
  }
  
  .feature-text {
    font-size: 0.9rem;
  }
  
  .welcome-section,
  .feature-section {
    padding: 1.5rem;
    margin: 1.5rem 0;
  }
  
  .feature-section li {
    font-size: 1rem;
  }
  
  .test-button {
    padding: 12px 24px;
    font-size: 1rem;
  }
  
  .quick-actions {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .query-input-section {
    flex-direction: column;
    gap: 1rem;
  }
  
  .query-input {
    min-width: 280px;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    white-space: normal;
  }
  
  .info-item span {
    text-align: left;
    margin-top: 0.5rem;
  }
  
  .file-item {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    align-items: center;
  }
  
  .file-item .file-info {
    width: 100%;
    text-align: center;
  }
  
  .file-item .file-info h4 {
    flex-wrap: wrap;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    gap: 0.5rem;
  }
  
  .file-item .file-info h4 .file-size {
    flex-shrink: 0;
  }
  
  .page-content {
    max-width: 100%;
    padding: 0 10px;
  }
  
  .security-notice-top {
    margin-bottom: 1.5rem;
    padding: 1rem;
  }
  
  .security-notice-top p {
    font-size: 0.9rem;
  }
}

/* 上传成功页面样式 */
.success-section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
}

.success-icon {
  margin-bottom: 2rem;
}

.checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  font-size: 3rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(76, 175, 80, 0.3);
  animation: checkmarkPulse 0.6s ease-out;
}

@keyframes checkmarkPulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-message {
  margin-bottom: 2rem;
}

.success-message h3 {
  color: #4CAF50;
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.success-message p {
  color: #e0e0e0;
  font-size: 1.1rem;
  line-height: 1.6;
}

.task-code-section {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 2rem;
  margin: 2rem 0;
  border: 2px solid rgba(33, 150, 243, 0.3);
}

.task-code-section h4 {
  color: #64B5F6;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.code-display {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.code-input {
  font-family: 'Courier New', monospace;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.8rem 1rem;
  border: 2px solid #2196f3;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  color: #1976d2;
  text-align: center;
  min-width: 200px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.code-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);
}

.code-input:hover {
  background: rgba(227, 242, 253, 0.9);
}

.copy-button {
  background: linear-gradient(135deg, #2196f3, #1976d2);
  color: white;
  border: none;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

.copy-button:hover {
  background: linear-gradient(135deg, #1976d2, #1565c0);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

.copy-button:active {
  transform: translateY(0);
}

.code-tip {
  margin-top: 1rem;
  padding: 0.8rem 1rem;
  background: rgba(33, 150, 243, 0.15);
  border: 1px solid rgba(33, 150, 243, 0.3);
  border-radius: 8px;
  text-align: center;
}

.code-tip p {
  margin: 0;
  color: #e3f2fd;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4;
}

.upload-info {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin: 2rem 0;
  text-align: left;
}

.upload-info h4 {
  color: #e0e0e0;
  margin-bottom: 1rem;
  text-align: center;
}

.success-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.secondary-button {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.secondary-button:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.success-tips {
  background: rgba(255, 193, 7, 0.2);
  border-radius: 12px;
  padding: 1.5rem;
  margin: 2rem 0;
  text-align: left;
  border-left: 4px solid #FFC107;
}

.success-tips h4 {
  color: #FFC107;
  margin-bottom: 1rem;
}

.success-tips ul {
  list-style: none;
  padding: 0;
}

.success-tips li {
  padding: 0.5rem 0;
  color: #e0e0e0;
  position: relative;
  padding-left: 1.5rem;
}

.success-tips li:before {
  content: "💡";
  position: absolute;
  left: 0;
  top: 0.5rem;
}

@media (max-width: 768px) {
  .code-display {
    flex-direction: column;
  }
  
  .code-input {
    min-width: 250px;
  }
  
  .code-tip p {
    font-size: 0.85rem;
  }
  
  .success-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .file-label {
    min-width: 250px;
    max-width: 320px;
    padding: 1.5rem;
  }
  
  .file-description {
    font-size: 0.85rem !important;
    margin: 0.2rem 0 0.4rem 0 !important;
  }
  
  .important-notice {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
  
  .important-notice h4 {
    font-size: 1.1rem;
  }
  
  .important-notice p {
    font-size: 1rem;
  }
  
  .download-button.primary {
    font-size: 0.9rem;
    padding: 0.8rem 1.5rem;
  }
}

/* 安全提示样式 */
.security-notice {
  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.security-notice p {
  margin: 0;
  color: #ffecb3;
  font-weight: 500;
}

/* 文件项过期状态样式 */
.file-item.expired {
  opacity: 0.7;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(244, 67, 54, 0.3);
}

/* 主要文件样式 */
.file-item.primary-file {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.15));
  border: 2px solid rgba(76, 175, 80, 0.5);
  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);
  position: relative;
}

.file-item.primary-file:hover {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.25), rgba(139, 195, 74, 0.2));
  transform: translateY(-3px);
  box-shadow: 0 6px 25px rgba(76, 175, 80, 0.3);
}

.file-item.primary-file::before {
  content: "⭐";
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 1.2rem;
  background: rgba(255, 193, 7, 0.9);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4);
}

/* 过期信息样式 */
.expiration-info {
  margin-top: 0.5rem;
  padding: 0.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.expiration-info.warning {
  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.3);
  color: #ffecb3;
}

.expiration-info.expired {
  background: rgba(244, 67, 54, 0.15);
  border: 1px solid rgba(244, 67, 54, 0.3);
  color: #ffcdd2;
}

.expiration-info .icon {
  font-size: 1rem;
}

.expiration-info .message {
  flex: 1;
  line-height: 1.4;
}

/* 新增顶部安全提示样式 */
.security-notice-top {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2), rgba(255, 152, 0, 0.15));
  border: 1px solid rgba(255, 193, 7, 0.4);
  border-radius: 10px;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
  backdrop-filter: blur(5px);
}

.security-notice-top p {
  margin: 0;
  color: #fff3c4;
  font-weight: 600;
  font-size: 1rem;
}



/* 主要下载按钮样式 */
.download-button.primary {
  background: linear-gradient(135deg, #4CAF50, #45a049) !important;
  border: 2px solid #4CAF50 !important;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.9rem 1.8rem;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
  color: white !important;
}

.download-button.primary:hover {
  background: linear-gradient(135deg, #45a049, #388e3c) !important;
  border-color: #45a049 !important;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.5);
}

/* --- 已选择大学的强制样式覆盖 --- */
.university-selection .selected-university .selected-name {
  color: #ffffff !important;
}

.university-selection .selected-university .selected-detail {
  color: rgba(255, 255, 255, 0.9) !important;
} 

.legal-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 18px;
  margin: 28px auto 10px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 13px;
}

.legal-footer a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
}

.legal-footer a:hover {
  text-decoration: underline;
}

/* Service purchase floating action button */
.purchase-fab {
  position: fixed;
  right: 26px;
  bottom: 128px;
  z-index: 1100;
  width: 86px;
  height: 86px;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(239, 68, 68, 0.45);
  animation: purchasePulse 1.8s infinite;
}

.purchase-fab:hover {
  transform: translateY(-2px) scale(1.02);
}

.purchase-fab-icon {
  font-size: 22px;
  line-height: 1;
}

.purchase-fab-text {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 700;
}

@keyframes purchasePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5), 0 14px 34px rgba(239, 68, 68, 0.45);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(239, 68, 68, 0), 0 14px 34px rgba(239, 68, 68, 0.45);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0), 0 14px 34px rgba(239, 68, 68, 0.45);
  }
}

/* Service purchase modal */
.purchase-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.purchase-modal {
  position: relative;
  width: min(520px, 96vw);
  max-height: min(92vh, 680px);
  overflow-y: auto;
  border-radius: 18px;
  background: #ffffff;
  padding: 28px;
  box-shadow: 0 24px 56px rgba(0, 0, 0, 0.3);
}

.purchase-modal h3 {
  margin: 0 0 10px;
  font-size: 24px;
  font-weight: 800;
  color: #111827;
}

.purchase-modal-desc {
  margin: 0 0 16px;
  color: #4b5563;
  font-size: 15px;
}

.purchase-service-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 16px 0 10px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
  padding: 14px 16px;
}

.purchase-service-summary div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.purchase-service-summary strong {
  color: #111827;
}

.purchase-service-summary span {
  color: #4b5563;
  font-size: 13px;
}

.purchase-modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.purchase-amount-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 16px 0;
}

.purchase-amount-btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  min-height: 112px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #f9fafb;
  padding: 12px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.purchase-amount-btn strong {
  color: #111827;
  font-size: 15px;
}

.purchase-amount-btn span {
  color: #4b5563;
  font-size: 13px;
}

.purchase-amount-btn small {
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.purchase-amount-btn.active {
  border-color: #ef4444;
  background: #fef2f2;
  color: #b91c1c;
}

.purchase-amount-btn.active strong,
.purchase-amount-btn.active span,
.purchase-amount-btn.active small {
  color: #b91c1c;
}

@media (max-width: 560px) {
  .purchase-amount-grid {
    grid-template-columns: 1fr;
  }
}

.purchase-error {
  margin-top: 10px;
  color: #b91c1c;
  font-size: 13px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 8px 10px;
}

.purchase-submit-btn {
  margin-top: 16px;
  width: 100%;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
  color: #ffffff;
  padding: 13px 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.purchase-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Service purchase result banner */
.purchase-result-banner {
  position: relative;
  margin: 0 auto 14px;
  width: min(980px, 96%);
  border-radius: 10px;
  padding: 13px 46px 13px 14px;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
}

.purchase-result-banner.success {
  color: #065f46;
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
}

.purchase-result-banner.cancel {
  color: #7c2d12;
  background: #fff7ed;
  border: 1px solid #fdba74;
}

.purchase-result-close {
  position: absolute;
  right: 10px;
  top: 7px;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ;;cAEY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oDAAoD;EACpD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,aAAa;AACb;EACE,oDAAoD;EACpD,YAAY;EACZ,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,aAAa;AACb;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,aAAa;EACb,MAAM;EACN,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA,UAAU;AACV;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA,cAAc;EACd;;IAEE,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,oDAAoD;EACpD,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,2CAA2C;EAC3C,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mFAAmF;EACnF,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;EACvF,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,qFAAqF;EACrF,wCAAwC;EACxC,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;EACrF,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,oFAAoF;EACpF,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;;;AAIA,aAAa;AACb;EACE,gEAAgE;EAChE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,gEAAgE;EAChE,gCAAgC;EAChC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,+EAA+E;EACjF;EACA;IACE,gFAAgF;EAClF;EACA;IACE,6EAA6E;EAC/E;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n}\n\n.App-header {\n  padding: 40px 20px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.App-header h1 {\n  font-size: 3rem;\n  margin-bottom: 2rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  animation: fadeInDown 1s ease-out;\n}\n\n.welcome-section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  margin: 2rem 0;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.welcome-section h2 {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  color: #fff;\n}\n\n.time-display {\n  font-size: 1.2rem;\n  color: #e0e0e0;\n  font-weight: 300;\n}\n\n.feature-section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  margin: 2rem 0;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  animation: fadeInUp 1s ease-out 0.4s both;\n}\n\n.feature-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #fff;\n}\n\n.feature-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.feature-section li {\n  font-size: 1.1rem;\n  margin: 0.8rem 0;\n  padding: 0.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  transition: transform 0.2s ease;\n}\n\n.feature-section li:hover {\n  transform: translateX(5px);\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.action-section {\n  margin: 2rem 0;\n  animation: fadeInUp 1s ease-out 0.6s both;\n}\n\n.test-button {\n  background: linear-gradient(45deg, #ff6b6b, #ee5a24);\n  border: none;\n  color: white;\n  padding: 15px 30px;\n  font-size: 1.1rem;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  font-weight: 600;\n}\n\n.test-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  background: linear-gradient(45deg, #ee5a24, #ff6b6b);\n}\n\n.test-button:active {\n  transform: translateY(0);\n}\n\n.App-footer {\n  margin-top: 3rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  color: #e0e0e0;\n  animation: fadeIn 1s ease-out 0.8s both;\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* 新增样式用于完整的Web应用界面 */\n\n.app-container {\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.page-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.hero-section {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.env-badge {\n  position: absolute;\n  top: -10px;\n  right: -20px;\n  background: linear-gradient(45deg, #f59e0b, #f97316);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: bold;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  animation: envBadgePulse 2s ease-in-out infinite;\n}\n\n@keyframes envBadgePulse {\n  0% {\n    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\n  }\n  50% {\n    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.6);\n  }\n  100% {\n    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\n  }\n}\n\n/* 测试环境徽章样式 */\n.env-badge.test-badge {\n  background: linear-gradient(45deg, #06B6D4, #0891B2);\n  color: white;\n  box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);\n  animation: testBadgePulse 2s ease-in-out infinite;\n}\n\n@keyframes testBadgePulse {\n  0% {\n    box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);\n  }\n  50% {\n    box-shadow: 0 4px 12px rgba(6, 182, 212, 0.6);\n  }\n  100% {\n    box-shadow: 0 2px 8px rgba(6, 182, 212, 0.4);\n  }\n}\n\n/* 大学选择功能样式 */\n.university-selection {\n  margin: 2rem 0;\n  padding: 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.university-label {\n  margin-bottom: 1rem;\n}\n\n.university-label label {\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n/* Tab页切换样式 */\n.university-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 1.5rem;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 20px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.55);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.tab-button:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.tab-button.active {\n  background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%);\n  color: #1e3a8a;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  border: none;\n}\n\n.tab-button:not(.active) {\n  background: rgba(255, 255, 255, 0.035);\n}\n\n/* 拼音搜索模式样式 */\n.search-mode {\n  position: relative;\n  margin-bottom: 30px;\n  /* 确保有足够空间显示搜索结果 */\n  min-height: 60px;\n}\n\n.search-input-container {\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.university-search-input {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #1a1a1a;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.university-search-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  background: rgba(255, 255, 255, 1);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n}\n\n.university-search-input::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.search-loading {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* 搜索结果下拉列表 */\n.search-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: rgba(255, 255, 255, 0.98);\n  border: 2px solid rgba(37, 99, 235, 0.4);\n  border-radius: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  margin-top: 4px;\n}\n\n.search-result-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(100, 181, 246, 0.1);\n  transition: background-color 0.2s ease;\n}\n\n.search-result-item:hover {\n  background: rgba(100, 181, 246, 0.1);\n}\n\n.search-result-item:last-child {\n  border-bottom: none;\n}\n\n.university-name {\n  color: #333;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.university-info {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 12px;\n}\n\n.search-no-results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  padding: 16px;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 14px;\n  font-weight: 500;\n  background: rgba(255, 255, 255, 0.98);\n  border: 2px solid rgba(37, 99, 235, 0.4);\n  border-radius: 10px;\n  margin-top: 4px;\n  z-index: 1000;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n}\n\n/* 三级联动选择模式样式 */\n.cascade-mode {\n  margin-bottom: 15px;\n}\n\n.cascade-selects {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cascade-select {\n  flex: 1;\n  min-width: 150px;\n  padding: 0.8rem 1rem;\n  border: 2px solid rgba(100, 181, 246, 0.3);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #333;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.cascade-select:focus {\n  outline: none;\n  border-color: #64B5F6;\n  box-shadow: 0 0 0 2px rgba(100, 181, 246, 0.2);\n}\n\n.cascade-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n.cascade-select option {\n  background: #fff;\n  color: #333;\n}\n\n/* 已选择的大学显示 */\n.selected-university {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.9);\n  border: 2px solid #16a34a;\n  border-radius: 10px;\n  padding: 14px 18px;\n  margin-bottom: 15px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.selected-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.selected-name {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 1.2rem;\n  text-shadow: none;\n  letter-spacing: 0.3px;\n}\n\n.selected-detail {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-shadow: none;\n}\n\n.clear-university-button {\n  padding: 8px 14px;\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.clear-university-button:hover {\n  background: linear-gradient(135deg, #dc2626, #b91c1c);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.4);\n}\n\n.university-tip {\n  margin-top: 0.5rem;\n}\n\n.university-tip p {\n  color: #e3f2fd;\n  font-size: 0.9rem;\n  margin: 0;\n  opacity: 0.8;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .cascade-selects {\n    flex-direction: column;\n  }\n  \n  .cascade-select {\n    min-width: unset;\n  }\n  \n  .selected-university {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .clear-university-button {\n    align-self: flex-end;\n  }\n  \n  .university-tabs {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .tab-button {\n    border-radius: 6px;\n  }\n  \n  /* 移动端搜索结果优化 */\n  .search-results,\n  .search-no-results {\n    margin: 0 10px;\n    max-width: calc(100vw - 40px);\n  }\n  \n  .search-mode {\n    margin-bottom: 40px;\n  }\n}\n\n/* 大学选择器组件样式 */\n.university-selector {\n  margin: 1.5rem 0;\n}\n\n.university-selector-header {\n  margin-bottom: 1rem;\n}\n\n.university-selector-header label {\n  color: #64B5F6;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.selected-university {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background: rgba(76, 175, 80, 0.1);\n  border: 2px solid rgba(76, 175, 80, 0.3);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.selected-info {\n  flex: 1;\n}\n\n.selected-name {\n  color: #4CAF50;\n  font-weight: bold;\n  font-size: 1.1rem;\n  margin-bottom: 0.3rem;\n}\n\n.selected-details {\n  color: #e8f5e8;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.clear-button {\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, #f44336, #d32f2f);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.clear-button:hover {\n  background: linear-gradient(135deg, #d32f2f, #c62828);\n  transform: translateY(-1px);\n}\n\n.university-input-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 2px dashed rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  margin-bottom: 1rem;\n}\n\n.university-input-placeholder span {\n  color: #e0e0e0;\n  opacity: 0.7;\n}\n\n.select-university-button {\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, #2196F3, #1976d2);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.select-university-button:hover {\n  background: linear-gradient(135deg, #1976d2, #1565c0);\n  transform: translateY(-1px);\n}\n\n/* 开发环境徽章样式 */\n.env-badge.dev-badge {\n  background: linear-gradient(45deg, #f59e0b, #f97316);\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.4);\n  animation: envBadgePulse 2s ease-in-out infinite;\n}\n\n.app-header h1 {\n  font-size: 2.5rem;\n  margin: 0;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  background: linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 700;\n}\n\n.app-icon {\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.app-icon:hover {\n  transform: scale(1.1) rotate(5deg);\n}\n\n.hero-description {\n  font-size: 1.2rem;\n  margin: 1rem 0;\n  color: #e0e0e0;\n}\n\n.hero-subtitle {\n  font-size: 1rem;\n  margin: 1rem 0 2rem 0;\n  color: #ffd700;\n  font-weight: 500;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin: 3rem 0;\n}\n\n.feature-card {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n}\n\n.supported-features {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  margin: 2rem 0;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.supported-features h3 {\n  text-align: center;\n  margin-bottom: 2rem;\n  font-size: 1.5rem;\n  color: #fff;\n}\n\n.features-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1rem;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  transition: all 0.3s ease;\n}\n\n.feature-item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateX(5px);\n}\n\n.feature-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.feature-text {\n  font-size: 0.95rem;\n  color: #e0e0e0;\n  line-height: 1.4;\n}\n\n.quick-actions {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.query-input {\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  min-width: 280px;\n}\n\n.query-input.large {\n  min-width: 300px;\n  padding: 15px 20px;\n  font-size: 1.1rem;\n}\n\n.query-button, .primary-button, .upload-button, .download-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.query-button {\n  background: linear-gradient(45deg, #4CAF50, #45a049);\n  color: white;\n}\n\n.primary-button {\n  background: linear-gradient(45deg, #2196F3, #1976D2);\n  color: white;\n  padding: 15px 30px;\n  font-size: 1.2rem;\n}\n\n.upload-button {\n  background: linear-gradient(45deg, #FF9800, #F57C00);\n  color: white;\n}\n\n.download-button {\n  background: linear-gradient(45deg, #9C27B0, #7B1FA2);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 100px;\n  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.3);\n}\n\n.download-button:hover {\n  background: linear-gradient(45deg, #7B1FA2, #6A1B9A);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.4);\n}\n\n.download-button.disabled {\n  background: linear-gradient(45deg, #757575, #616161);\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n  box-shadow: none;\n}\n\n.download-button:disabled {\n  background: linear-gradient(45deg, #757575, #616161);\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n  box-shadow: none;\n}\n\n.back-button {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 1rem;\n}\n\n.page-header {\n  margin-bottom: 2rem;\n}\n\n.upload-section, .query-section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.query-input-section {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.query-error {\n  margin: 1rem 0;\n  padding: 1rem 1.5rem;\n  background: rgba(244, 67, 54, 0.15);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 8px;\n  text-align: center;\n  animation: fadeInUp 0.3s ease-out;\n}\n\n.query-error p {\n  margin: 0;\n  color: #ffcdd2;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.upload-area {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-label {\n  display: inline-block;\n  padding: 2rem;\n  border: 2px dashed rgba(255, 255, 255, 0.5);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 300px;\n  max-width: 500px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n\n.file-label:hover {\n  border-color: rgba(255, 255, 255, 0.8);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.file-info {\n  margin-top: 1rem;\n  color: #e0e0e0;\n}\n\n.upload-tips {\n  margin-top: 2rem;\n  text-align: left;\n}\n\n.upload-tips ul {\n  list-style-type: disc;\n  padding-left: 2rem;\n}\n\n.upload-tips li {\n  margin: 0.5rem 0;\n  color: #e0e0e0;\n}\n\n.important-notice {\n  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2), rgba(255, 152, 0, 0.1));\n  border: 2px solid #FFC107;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  backdrop-filter: blur(5px);\n  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);\n  animation: pulse-warning 2s ease-in-out infinite;\n}\n\n.important-notice h4 {\n  color: #FFC107;\n  font-size: 1.3rem;\n  margin-bottom: 1rem;\n  font-weight: 700;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.important-notice p {\n  color: #fff3c4;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n  line-height: 1.5;\n}\n\n@keyframes pulse-warning {\n  0% {\n    box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);\n  }\n  50% {\n    box-shadow: 0 6px 20px rgba(255, 193, 7, 0.5);\n  }\n  100% {\n    box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);\n  }\n}\n\n.process-steps {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.process-steps h4 {\n  margin-bottom: 1.5rem;\n  color: #64B5F6;\n  font-size: 1.1rem;\n}\n\n.steps {\n  display: grid;\n  gap: 1rem;\n}\n\n.step {\n  padding: 1rem;\n  background: rgba(33, 150, 243, 0.1);\n  border-radius: 8px;\n  border-left: 4px solid #2196F3;\n  color: #e3f2fd;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n}\n\n.step:hover {\n  background: rgba(33, 150, 243, 0.15);\n  transform: translateX(5px);\n}\n\n.task-result {\n  margin-top: 2rem;\n}\n\n.task-info {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 6px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: #e0e0e0;\n  margin-right: 1rem;\n  flex-shrink: 0;\n}\n\n.info-item span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-align: right;\n}\n\n.status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n}\n\n.status.pending {\n  background: #FFC107;\n  color: #000;\n}\n\n.status.processing {\n  background: #2196F3;\n  color: white;\n}\n\n.status.completed {\n  background: #4CAF50;\n  color: white;\n}\n\n.status.failed {\n  background: #F44336;\n  color: white;\n}\n\n.error-message {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: rgba(244, 67, 54, 0.2);\n  border-radius: 8px;\n  border-left: 4px solid #F44336;\n}\n\n.error-code {\n  background: rgba(244, 67, 54, 0.4);\n  color: #ffcdd2;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.result-files {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 2rem;\n}\n\n.file-list {\n  display: grid;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.file-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.file-item:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.file-item .file-info h4 {\n  margin: 0 0 0.3rem 0;\n  color: white;\n  font-size: 1.2rem;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: help;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.file-item .file-info p {\n  margin: 0.5rem 0;\n  color: #e0e0e0;\n  font-size: 0.95rem;\n}\n\n.file-description {\n  font-size: 0.9rem !important;\n  color: #e0e0e0 !important;\n  line-height: 1.4;\n  margin: 0.2rem 0 0.5rem 0 !important;\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: initial !important;\n}\n\n.file-size {\n  color: #bbb;\n  font-size: 0.85rem;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.file-item .file-info h4 .file-size {\n  color: #ccc;\n  font-size: 0.9rem;\n  font-weight: 400;\n  flex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n  .App-header h1 {\n    font-size: 2rem;\n  }\n  \n  .app-header {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .app-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .app-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .hero-subtitle {\n    font-size: 0.9rem;\n    margin: 1rem 0 1.5rem 0;\n  }\n  \n  .features-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .feature-item {\n    padding: 0.8rem;\n  }\n  \n  .feature-text {\n    font-size: 0.9rem;\n  }\n  \n  .welcome-section,\n  .feature-section {\n    padding: 1.5rem;\n    margin: 1.5rem 0;\n  }\n  \n  .feature-section li {\n    font-size: 1rem;\n  }\n  \n  .test-button {\n    padding: 12px 24px;\n    font-size: 1rem;\n  }\n  \n  .quick-actions {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  .query-input-section {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .query-input {\n    min-width: 280px;\n  }\n  \n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    white-space: normal;\n  }\n  \n  .info-item span {\n    text-align: left;\n    margin-top: 0.5rem;\n  }\n  \n  .file-item {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n    align-items: center;\n  }\n  \n  .file-item .file-info {\n    width: 100%;\n    text-align: center;\n  }\n  \n  .file-item .file-info h4 {\n    flex-wrap: wrap;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: initial;\n    gap: 0.5rem;\n  }\n  \n  .file-item .file-info h4 .file-size {\n    flex-shrink: 0;\n  }\n  \n  .page-content {\n    max-width: 100%;\n    padding: 0 10px;\n  }\n  \n  .security-notice-top {\n    margin-bottom: 1.5rem;\n    padding: 1rem;\n  }\n  \n  .security-notice-top p {\n    font-size: 0.9rem;\n  }\n}\n\n/* 上传成功页面样式 */\n.success-section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 2rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  text-align: center;\n}\n\n.success-icon {\n  margin-bottom: 2rem;\n}\n\n.checkmark {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4CAF50, #45a049);\n  color: white;\n  font-size: 3rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  box-shadow: 0 8px 32px rgba(76, 175, 80, 0.3);\n  animation: checkmarkPulse 0.6s ease-out;\n}\n\n@keyframes checkmarkPulse {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.success-message {\n  margin-bottom: 2rem;\n}\n\n.success-message h3 {\n  color: #4CAF50;\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n}\n\n.success-message p {\n  color: #e0e0e0;\n  font-size: 1.1rem;\n  line-height: 1.6;\n}\n\n.task-code-section {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 2rem;\n  margin: 2rem 0;\n  border: 2px solid rgba(33, 150, 243, 0.3);\n}\n\n.task-code-section h4 {\n  color: #64B5F6;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n.code-display {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.code-input {\n  font-family: 'Courier New', monospace;\n  font-size: 1.2rem;\n  font-weight: bold;\n  padding: 0.8rem 1rem;\n  border: 2px solid #2196f3;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #1976d2;\n  text-align: center;\n  min-width: 200px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);\n}\n\n.code-input:hover {\n  background: rgba(227, 242, 253, 0.9);\n}\n\n.copy-button {\n  background: linear-gradient(135deg, #2196f3, #1976d2);\n  color: white;\n  border: none;\n  padding: 0.8rem 1.2rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);\n}\n\n.copy-button:hover {\n  background: linear-gradient(135deg, #1976d2, #1565c0);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);\n}\n\n.copy-button:active {\n  transform: translateY(0);\n}\n\n.code-tip {\n  margin-top: 1rem;\n  padding: 0.8rem 1rem;\n  background: rgba(33, 150, 243, 0.15);\n  border: 1px solid rgba(33, 150, 243, 0.3);\n  border-radius: 8px;\n  text-align: center;\n}\n\n.code-tip p {\n  margin: 0;\n  color: #e3f2fd;\n  font-size: 0.9rem;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.upload-info {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin: 2rem 0;\n  text-align: left;\n}\n\n.upload-info h4 {\n  color: #e0e0e0;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.success-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin: 2rem 0;\n  flex-wrap: wrap;\n}\n\n.secondary-button {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  padding: 0.8rem 2rem;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.secondary-button:hover {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2));\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);\n}\n\n.success-tips {\n  background: rgba(255, 193, 7, 0.2);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin: 2rem 0;\n  text-align: left;\n  border-left: 4px solid #FFC107;\n}\n\n.success-tips h4 {\n  color: #FFC107;\n  margin-bottom: 1rem;\n}\n\n.success-tips ul {\n  list-style: none;\n  padding: 0;\n}\n\n.success-tips li {\n  padding: 0.5rem 0;\n  color: #e0e0e0;\n  position: relative;\n  padding-left: 1.5rem;\n}\n\n.success-tips li:before {\n  content: \"💡\";\n  position: absolute;\n  left: 0;\n  top: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .code-display {\n    flex-direction: column;\n  }\n  \n  .code-input {\n    min-width: 250px;\n  }\n  \n  .code-tip p {\n    font-size: 0.85rem;\n  }\n  \n  .success-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .file-label {\n    min-width: 250px;\n    max-width: 320px;\n    padding: 1.5rem;\n  }\n  \n  .file-description {\n    font-size: 0.85rem !important;\n    margin: 0.2rem 0 0.4rem 0 !important;\n  }\n  \n  .important-notice {\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .important-notice h4 {\n    font-size: 1.1rem;\n  }\n  \n  .important-notice p {\n    font-size: 1rem;\n  }\n  \n  .download-button.primary {\n    font-size: 0.9rem;\n    padding: 0.8rem 1.5rem;\n  }\n}\n\n/* 安全提示样式 */\n.security-notice {\n  background: rgba(255, 193, 7, 0.15);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.security-notice p {\n  margin: 0;\n  color: #ffecb3;\n  font-weight: 500;\n}\n\n/* 文件项过期状态样式 */\n.file-item.expired {\n  opacity: 0.7;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n/* 主要文件样式 */\n.file-item.primary-file {\n  background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.15));\n  border: 2px solid rgba(76, 175, 80, 0.5);\n  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.2);\n  position: relative;\n}\n\n.file-item.primary-file:hover {\n  background: linear-gradient(135deg, rgba(76, 175, 80, 0.25), rgba(139, 195, 74, 0.2));\n  transform: translateY(-3px);\n  box-shadow: 0 6px 25px rgba(76, 175, 80, 0.3);\n}\n\n.file-item.primary-file::before {\n  content: \"⭐\";\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  font-size: 1.2rem;\n  background: rgba(255, 193, 7, 0.9);\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.4);\n}\n\n/* 过期信息样式 */\n.expiration-info {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.expiration-info.warning {\n  background: rgba(255, 193, 7, 0.15);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  color: #ffecb3;\n}\n\n.expiration-info.expired {\n  background: rgba(244, 67, 54, 0.15);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  color: #ffcdd2;\n}\n\n.expiration-info .icon {\n  font-size: 1rem;\n}\n\n.expiration-info .message {\n  flex: 1;\n  line-height: 1.4;\n}\n\n/* 新增顶部安全提示样式 */\n.security-notice-top {\n  background: linear-gradient(135deg, rgba(255, 193, 7, 0.2), rgba(255, 152, 0, 0.15));\n  border: 1px solid rgba(255, 193, 7, 0.4);\n  border-radius: 10px;\n  padding: 1rem 1.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  backdrop-filter: blur(5px);\n}\n\n.security-notice-top p {\n  margin: 0;\n  color: #fff3c4;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n\n\n/* 主要下载按钮样式 */\n.download-button.primary {\n  background: linear-gradient(135deg, #4CAF50, #45a049) !important;\n  border: 2px solid #4CAF50 !important;\n  font-weight: 700;\n  font-size: 1rem;\n  padding: 0.9rem 1.8rem;\n  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);\n  color: white !important;\n}\n\n.download-button.primary:hover {\n  background: linear-gradient(135deg, #45a049, #388e3c) !important;\n  border-color: #45a049 !important;\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.5);\n}\n\n/* --- 已选择大学的强制样式覆盖 --- */\n.university-selection .selected-university .selected-name {\n  color: #ffffff !important;\n}\n\n.university-selection .selected-university .selected-detail {\n  color: rgba(255, 255, 255, 0.9) !important;\n} \n\n.legal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px 18px;\n  margin: 28px auto 10px;\n  color: rgba(255, 255, 255, 0.84);\n  font-size: 13px;\n}\n\n.legal-footer a {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n}\n\n.legal-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Service purchase floating action button */\n.purchase-fab {\n  position: fixed;\n  right: 26px;\n  bottom: 128px;\n  z-index: 1100;\n  width: 86px;\n  height: 86px;\n  border: none;\n  border-radius: 9999px;\n  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 14px 34px rgba(239, 68, 68, 0.45);\n  animation: purchasePulse 1.8s infinite;\n}\n\n.purchase-fab:hover {\n  transform: translateY(-2px) scale(1.02);\n}\n\n.purchase-fab-icon {\n  font-size: 22px;\n  line-height: 1;\n}\n\n.purchase-fab-text {\n  margin-top: 4px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n@keyframes purchasePulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5), 0 14px 34px rgba(239, 68, 68, 0.45);\n  }\n  70% {\n    box-shadow: 0 0 0 12px rgba(239, 68, 68, 0), 0 14px 34px rgba(239, 68, 68, 0.45);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0), 0 14px 34px rgba(239, 68, 68, 0.45);\n  }\n}\n\n/* Service purchase modal */\n.purchase-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.purchase-modal {\n  position: relative;\n  width: min(520px, 96vw);\n  max-height: min(92vh, 680px);\n  overflow-y: auto;\n  border-radius: 18px;\n  background: #ffffff;\n  padding: 28px;\n  box-shadow: 0 24px 56px rgba(0, 0, 0, 0.3);\n}\n\n.purchase-modal h3 {\n  margin: 0 0 10px;\n  font-size: 24px;\n  font-weight: 800;\n  color: #111827;\n}\n\n.purchase-modal-desc {\n  margin: 0 0 16px;\n  color: #4b5563;\n  font-size: 15px;\n}\n\n.purchase-service-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: 16px 0 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #eff6ff;\n  padding: 14px 16px;\n}\n\n.purchase-service-summary div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.purchase-service-summary strong {\n  color: #111827;\n}\n\n.purchase-service-summary span {\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.purchase-modal-close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 30px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.purchase-amount-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin: 16px 0;\n}\n\n.purchase-amount-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 4px;\n  min-height: 112px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #f9fafb;\n  padding: 12px;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n}\n\n.purchase-amount-btn strong {\n  color: #111827;\n  font-size: 15px;\n}\n\n.purchase-amount-btn span {\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.purchase-amount-btn small {\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.purchase-amount-btn.active {\n  border-color: #ef4444;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.purchase-amount-btn.active strong,\n.purchase-amount-btn.active span,\n.purchase-amount-btn.active small {\n  color: #b91c1c;\n}\n\n@media (max-width: 560px) {\n  .purchase-amount-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.purchase-error {\n  margin-top: 10px;\n  color: #b91c1c;\n  font-size: 13px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n\n.purchase-submit-btn {\n  margin-top: 16px;\n  width: 100%;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);\n  color: #ffffff;\n  padding: 13px 14px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.purchase-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Service purchase result banner */\n.purchase-result-banner {\n  position: relative;\n  margin: 0 auto 14px;\n  width: min(980px, 96%);\n  border-radius: 10px;\n  padding: 13px 46px 13px 14px;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.purchase-result-banner.success {\n  color: #065f46;\n  background: #ecfdf5;\n  border: 1px solid #6ee7b7;\n}\n\n.purchase-result-banner.cancel {\n  color: #7c2d12;\n  background: #fff7ed;\n  border: 1px solid #fdba74;\n}\n\n.purchase-result-close {\n  position: absolute;\n  right: 10px;\n  top: 7px;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
